'use strict';

class XHR {
  static Obj() {
    if (typeof XMLHttpRequest !== 'undefined') {
      return new XMLHttpRequest();
    }

    let versions = [
      "MSXML2.XmlHttp.6.0",
      "MSXML2.XmlHttp.5.0",
      "MSXML2.XmlHttp.4.0",
      "MSXML2.XmlHttp.3.0",
      "MSXML2.XmlHttp.2.0",
      "Microsoft.XmlHttp"
    ];

    let xhr;
    for (let i = 0; i < versions.length; i++) {
      try {
        xhr = new ActiveXObject(versions[i]);
        break;
      } catch (e) {
      }
    }

    return xhr;
  }

  static _getStandardMethod(method) {
    return method.split("-")[0];
  }


  // @url:            string. request url
  // @method:         string. 'GET', 'POST', 'PUT', 'DELETE' or 'POST-FILE'
  // @data:           object. key-value pairs
  // @headers:        object. key-value pairs
  // @isAsync:        boolean. wheather this request acts as an asynchronous one, default is true
  // @isResponseJson: boolean. whether response data of this request is in json formate, default is true
  // @file:           file. file type data, only be processed when method is 'POST-FILE'
  // @fileKey:        string. the key for the @file in the request form, only be processed when method is 'POST-FILE'
  static send(url, method, data, headers, isAsync, isResponseJson, file, fileKey) {
    if (isAsync === undefined) {
      isAsync = true;
    }
    if (isResponseJson === undefined) {
      isResponseJson = true;
    }

    return (new Promise((resolve, reject) => {
      let xhr = XHR.Obj();

      if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1)) {
        // IE 11 not support timeout
      } else {
        if(isAsync) {
          xhr.timeout = 180000; // 180s timeout
        }
      }
      xhr.open(XHR._getStandardMethod(method), url, isAsync);

      if (headers) {
        for (let key in headers) {
          if (headers.hasOwnProperty(key)) {
            xhr.setRequestHeader(key, headers[key]);
          }
        }
      }

      if (method != 'GET' && method != 'POST-FILE')
        xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          if (isResponseJson)
            resolve(JSON.parse(xhr.response));
          else
            resolve(xhr.response);
        } else {
          reject({
            status      : this.status,
            errorMessage: isResponseJson ? JSON.parse(xhr.response) : xhr.response
          });
        }
      };

      xhr.onerror = function () {
        reject({
          status      : this.status,
          errorMessage: xhr.statusText
        });
      };

      xhr.ontimeout = function () {
        reject({
          status      : this.status,
          errorMessage: xhr.statusText
        });
      };

      let requestData = data;
      if (method == 'POST-FILE') {
        requestData = new FormData();
        requestData.append(fileKey, file);
        if (data)
          for (let key in data)
            requestData.append(key, data[key]);
      }
      xhr.send(requestData);
    }));
  }
}

export default class AjaxBase {
  // change value to string
  //    1 ==> "1"
  //    "Helle World" ==> "Helle%20World"
  //    {a: 1, b: 2} ==> '{"a":1,"b":2}'
  static _toString(value) {
    if (value == undefined || value == null)
      return "";

    if (typeof value != "string")
      return JSON.stringify(value);
    else
      return encodeURIComponent(value);
  }

  // change data from object to string. E.g.,
  //     {key1: valud1, key2: value2} ==> "key1=valud1&key2=value2"
  static _reformData(data, isJson) {
    if (isJson === undefined) {
      isJson = true;
    }

    // data ? (data.token = "e0e88f754b17d67f3e7977354ab9d7fe") : (data = {token: "e0e88f754b17d67f3e7977354ab9d7fe"});    // only for debug

    if (isJson)
      return data ? JSON.stringify(data) : '';

    let query = [];
    for (let key in data) {
      if (Array.isArray(data[key]))
        data[key].forEach((element, index) => {
          query.push(encodeURIComponent(key) + '[]=' + AjaxBase._toString(element));
        });
      else if (!(data[key] == undefined || data[key] == null)) {
        query.push(encodeURIComponent(key) + '=' + AjaxBase._toString(data[key]));
      }
    }
    return query.join("&");
  }

  static get URL_PREFIX() {
    return "/api/v1/";
  }

  // Normal call may only provide url & data.
  // @url:            string, request url, demain is not required.
  // @data:           object, e.g., {key1: valud1, key2: value2}
  // @headers:        object, can be undefined or {}, unless you want to override default header setting
  // @isAsync:        boolean, sending a asynchronized request, or not (synchronized). Default is true.
  // @isResponseJson: boolean, response data in JSON format, or not (in string format). Dafault is true.
  // @file:           file,
  // @fileKey:        string, key for the file parameter
  static get(url, data, headers, isAsync, isResponseJson) {
    let dataStr = AjaxBase._reformData(data, false);
    return XHR.send(url + (dataStr.length ? '?' + dataStr : ''), 'GET', null, headers, isAsync, isResponseJson);
  }

  static post(url, data, headers, isAsync, isResponseJson) {
    let dataStr = AjaxBase._reformData(data);
    return XHR.send(url, 'POST', dataStr, headers, isAsync, isResponseJson);
  }

  static put(url, data, headers, isAsync, isResponseJson) {
    let dataStr = AjaxBase._reformData(data);
    return XHR.send(url, 'PUT', dataStr, headers, isAsync, isResponseJson);
  }

  static delete(url, data, headers, isAsync, isResponseJson) {
    let dataStr = AjaxBase._reformData(data);
    return XHR.send(url, 'DELETE', dataStr, headers, isAsync, isResponseJson);
  }

  static uploadFile(url, data, headers, isAsync, isResponseJson, file, fileKey) {
    return XHR.send(url, 'POST-FILE', data, headers, isAsync, isResponseJson, file, fileKey);
  }
}


// WEBPACK FOOTER //
// ./app/javascript/lib/AjaxBase.js